var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{class:`tab ${_vm.active ? 'active' : ''}`,attrs:{"href":_vm.link},on:{"click":function($event){$event.preventDefault();return _vm.emit($event)}}},[(_vm.icon)?_c('i',{class:`icon-${_vm.icon}`}):_vm._e(),(_vm.title)?[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.title))])]:[_c('div',{staticClass:"label"},[_vm._t("default")],2)]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }